<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
(function() {
  'use strict';
  
  function expandTabsOnMobile() {
    if (window.innerWidth >= 768) return;
    
    const tabButtons = document.querySelectorAll('[role="tab"], .tab-button, .accordion-header');
    
    tabButtons.forEach((button, index) => {
      setTimeout(() => {
        button.setAttribute('aria-expanded', 'true');
        button.classList.add('active');
        
        const tabPanel = button.getAttribute('aria-controls');
        if (tabPanel) {
          const content = document.getElementById(tabPanel);
          if (content) {
            content.style.display = 'block';
            content.style.maxHeight = 'none';
          }
        }
        
        button.click();
      }, 50 * index);
    });
  }
  
  document.addEventListener('DOMContentLoaded', expandTabsOnMobile);
  setTimeout(expandTabsOnMobile, 500);
})();